<script>
import Carregando from '~componentes/Carregando.vue';
import conciliacaoProjetoServico from '../servico';
import permissoesConciliacao from '~js/permissoes-conciliacao';

export default {
  components: {
    Carregando
  },
  data() {
    return {
      carregando: true,
      erro: '',
      acao: '',
    }
  },
  computed: {
    titulo() {
      if (this.acao === 'tesouraria') return 'Posição de Tesouraria';
      if (this.acao === 'banco') return 'Conciliação de Banco';
      return 'Conciliação de Projetos';
    },
  },
  mounted() {
    this.iniciarSessao();
  },
  methods: {
    iniciarSessao() {
      const token = this.$route.query.token;

      if (!token) {
        this.carregando = false;
        this.erro = 'Não foi possível abrir a conciliação. Acesse novamente pelo sistema.';
        return;
      }

      this.$storage.limpar();

      return conciliacaoProjetoServico
        .iniciarSessao(token)
        .then(dados => {
          this.$storage.usuario(dados.usuario);
          this.$storage.token(dados.token);

          const parametros = dados.parametros;
          this.acao = parametros && parametros.acao ? parametros.acao : '';

          if (parametros && parametros.acao === 'tesouraria') {
            if (!permissoesConciliacao.consultar('tesouraria')) {
              this.carregando = false;
              this.erro = 'Você não tem permissão para acessar a posição de tesouraria. Solicite a liberação no cadastro de usuários.';
              return;
            }

            this.$router.replace({
              name: 'posicao-tesouraria',
              query: parametros.idContaCript ? { conta: parametros.idContaCript } : {},
            });
            return;
          }

          const banco = !!(parametros && parametros.acao === 'banco');

          if (!permissoesConciliacao.consultar(banco ? 'banco' : 'projeto')) {
            if (permissoesConciliacao.consultar(banco ? 'projeto' : 'banco')) {
              this.$router.replace({ name: banco ? 'conciliacao-projeto' : 'conciliacao-banco' });
              return;
            }

            this.carregando = false;
            this.erro = banco
              ? 'Você não tem permissão para acessar a conciliação de banco. Solicite a liberação no cadastro de usuários.'
              : 'Você não tem permissão para acessar a conciliação de projetos. Solicite a liberação no cadastro de usuários.';
            return;
          }

          if (banco) {
            if (parametros.idContaCript) {
              this.$router.replace({
                name: 'conciliacao-banco.tela',
                params: { idContaCript: parametros.idContaCript },
              });
              return;
            }
            this.$router.replace({ name: 'conciliacao-banco', query: parametros.extratoPendente ? { extrato: '1' } : {} });
            return;
          }

          if (parametros && parametros.idProjetoCript) {
            this.$router.replace({
              name: 'conciliacao-projeto.tela',
              params: { idProjetoCript: parametros.idProjetoCript },
            });
            return;
          }

          this.$router.replace({ name: 'conciliacao-projeto' });
        })
        .catch(resposta => {
          this.carregando = false;

          const mensagem = resposta && resposta.data ? resposta.data.message : '';
          this.acao = resposta && resposta.data && resposta.data.acao ? resposta.data.acao : '';

          this.erro = resposta && resposta.status === 403 && mensagem
            ? mensagem
            : 'Sessão expirada ou inválida. Feche esta janela e abra novamente pelo sistema.';
        });
    },
  }
}
</script>

<template>
  <div>
    <carregando v-if="carregando"></carregando>

    <div v-if="erro" class="ibox float-e-margins">
      <div class="ibox-content text-center">
        <h2>{{ titulo }}</h2>
        <div class="alert alert-warning no-margin-bottom">
          {{ erro }}
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/Sessao.vue